import { colors } from '@/theme/tokens';
import {
  BlockOutlinedIcon,
  CancelOutlinedIcon,
  CheckCircleOutlineIcon,
  BuildsIcon,
  DonutLargeIcon,
  DriveFileMoveIcon,
  EditOutlinedIcon,
  ErrorOutline,
  EventAvailableOutlinedIcon,
  EventBusyOutlinedIcon,
  EventOutlinedIcon,
  HelpOutline,
  PlayCircleFilledWhiteOutlinedIcon,
  ReleasesIcon,
  ScheduleOutlinedIcon,
  StagesIcon,
  SuitesIcon,
  TestsIcon,
} from '@/ui/primitives/icons';
import type { MetricCardItem } from '@/features/metrics/components/statusMetricCards';
import type { MetricsScope } from '@/features/metrics/metricsHelpers';
import type { SvgIconComponent } from '@/ui/primitives';

export const resolveStackedStatusCardIcon = (
  statusId: string,
  scope: MetricsScope,
): SvgIconComponent => {
  if (statusId === 'draft') return EditOutlinedIcon;
  if (statusId === 'planned') return EventOutlinedIcon;
  if (statusId === 'ready') return EventAvailableOutlinedIcon;
  if (statusId === 'overdue') return EventBusyOutlinedIcon;
  if (statusId === 'released') return ReleasesIcon;
  if (statusId === 'passed' || statusId === 'completed' || statusId === 'success') {
    return CheckCircleOutlineIcon;
  }
  if (statusId === 'failed') return CancelOutlinedIcon;
  if (statusId === 'errored') return ErrorOutline;
  if (statusId === 'running') return PlayCircleFilledWhiteOutlinedIcon;
  if (statusId === 'queued') return ScheduleOutlinedIcon;
  if (statusId === 'none') return DonutLargeIcon;
  if (statusId === 'skipped') return BlockOutlinedIcon;
  if (statusId === 'untested') return HelpOutline;
  if (statusId === 'total' && scope === 'executionRun') return PlayCircleFilledWhiteOutlinedIcon;
  if (statusId === 'total' && scope === 'pipeline') return BuildsIcon;
  if (statusId === 'total' && scope === 'stage') return DriveFileMoveIcon;
  if (statusId === 'total' && scope === 'job') return StagesIcon;
  if (statusId === 'total' && scope === 'suite') return SuitesIcon;
  if (statusId === 'total' && scope === 'test') return TestsIcon;
  return DonutLargeIcon;
};

export const resolveGenericStatusCardIcon = (statusId: string): SvgIconComponent => {
  if (statusId === 'draft') return EditOutlinedIcon;
  if (statusId === 'planned') return EventOutlinedIcon;
  if (statusId === 'ready') return EventAvailableOutlinedIcon;
  if (statusId === 'overdue') return EventBusyOutlinedIcon;
  if (statusId === 'released') return ReleasesIcon;
  if (statusId === 'passed' || statusId === 'completed' || statusId === 'success') {
    return CheckCircleOutlineIcon;
  }
  if (statusId === 'failed') return CancelOutlinedIcon;
  if (statusId === 'errored') return ErrorOutline;
  if (statusId === 'running') return PlayCircleFilledWhiteOutlinedIcon;
  if (statusId === 'queued') return ScheduleOutlinedIcon;
  if (statusId === 'none' || statusId === 'total') return DonutLargeIcon;
  if (statusId === 'skipped') return BlockOutlinedIcon;
  if (statusId === 'untested') return HelpOutline;
  return DonutLargeIcon;
};

export const resolveStackedStatusCardIconColor = (
  statusTone: MetricCardItem['statusTone'],
): string => {
  if (statusTone === 'success') return colors.light.success;
  if (statusTone === 'error') return colors.light.danger;
  if (statusTone === 'warning') return colors.light.warning;
  if (statusTone === 'brown') return colors.light.brown;
  if (statusTone === 'primary') return colors.light.primary;
  if (statusTone === 'info') return colors.light.info;
  return colors.light.neutral;
};
